import { motion } from "framer-motion";

const CROPS = [
  { name: "Avocado Groves", area: "Homestead · Redland" },
  { name: "Mango & Tropical Fruit", area: "Florida City · Princeton" },
  { name: "Tomato & Squash", area: "Miami-Dade row crops" },
  { name: "Sweet Corn", area: "Krome & Naranja basin" },
  { name: "Sugarcane", area: "Florida City · Glades edge" },
  { name: "Ornamental Nurseries", area: "Redland Agricultural Area" },
  { name: "Citrus & Limes", area: "Homestead orchards" },
  { name: "Beans & Okra", area: "South Miami-Dade fields" },
];

export default function Crops() {
  return (
    <section id="crops" data-testid="crops-section" className="py-24 md:py-32 bg-primary text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-[0.06] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-accent mb-4">Crops we serve</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            Crops We Serve: Avocados, Tomatoes, Citrus, <span className="text-accent">Row Crops, Nurseries</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-primary-foreground/80">
            Whether you're farming the Redland's limestone soils or running sweet-corn rows near Krome Avenue, our
            drones adapt to canopy, slope and field shape.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {CROPS.map((c, i) => (
            <motion.div
              key={c.name}
              data-testid={`crop-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="rounded-2xl p-5 border border-white/10 bg-white/5 hover:bg-white/10 hover:border-accent/40 transition-all"
            >
              <div className="font-display text-lg font-semibold">{c.name}</div>
              <div className="mt-1 text-xs text-primary-foreground/65">{c.area}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
